import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagPaseConsumosFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='' htmlFor='checkbox-flagPaseConsumos' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='flagPaseConsumos'>
          {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagPaseConsumos' label='Pase Consumos' />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagPaseConsumosFormGroup)
